import React, { useState } from "react";
import { ArrowLeft, Shield, Users, BarChart3, SlidersHorizontal, Receipt, Ban } from "lucide-react";
import { UsersSection, BlockSection } from "../components/admin/UsersSection";
import { UsageSection } from "../components/admin/UsageSection";
import { PricesSection } from "../components/admin/PricesSection";
import { TransactionsSection } from "../components/admin/TransactionsSection";

const SECTIONS = [
  ["users", "Users & credits", Users, UsersSection],
  ["usage", "Usage & spend", BarChart3, UsageSection],
  ["prices", "Prices & limits", SlidersHorizontal, PricesSection],
  ["transactions", "Payments & transactions", Receipt, TransactionsSection],
  ["block", "Block / unblock", Ban, BlockSection],
];

export default function AdminPage() {
  const [tab, setTab] = useState(() => { const q = new URLSearchParams(window.location.search); return q.get("admin") || q.get("s") || "users"; });
  const active = SECTIONS.find((s) => s[0] === tab) || SECTIONS[0];
  const Section = active[3];
  const go = (k) => { setTab(k); window.history.replaceState(null, "", `/?admin=${k}`); };
  return (
    <div className="min-h-screen bg-[#000000] text-slate-100" data-testid="admin-page">
      <header className="sticky top-0 z-20 border-b border-white/10 bg-[#000000]/95 backdrop-blur">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <a href="/" data-testid="admin-back" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-mono-400/50" title="Back to app"><ArrowLeft className="w-4 h-4" /></a>
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-white" />
            <div>
              <div className="label-mono !text-slate-300">Admin area</div>
              <h1 className="font-heading text-lg font-normal leading-tight" data-testid="admin-section-title">{active[1]}</h1>
            </div>
          </div>
        </div>
        <nav className="max-w-3xl mx-auto px-2 pb-2 flex gap-1 overflow-x-auto thin-scroll" data-testid="admin-tabs">
          {SECTIONS.map(([k, label, Icon]) => (
            <button key={k} data-testid={`admin-tab-${k}`} onClick={() => go(k)}
              className={`shrink-0 rounded-full px-3 py-1.5 text-xs flex items-center gap-1.5 transition-colors ${tab === k ? "bg-white/10 text-white border border-white/25" : "text-slate-400 border border-transparent hover:text-white"}`}>
              <Icon className="w-3.5 h-3.5" /> {label}
            </button>
          ))}
        </nav>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-5"><Section /></main>
    </div>
  );
}
